<template>
    <nav class="app-nav navbar navbar-expand-md navbar-light bg-white sticky-top">
        <div class="container-fluid">

            <div class="navbar-brand logo-wrap" :class="{'mx-auto': !$page.props.student}">
                <img :src="theme_logo" class="logo" alt="">
            </div>

            <div class="collapse navbar-collapse" v-if="$page.props.student">
                <!-- Left Side Of Navbar -->
                <ul class="navbar-nav mr-auto nav-left">

                </ul>

                <ul class="navbar-nav ml-auto nav-right align-items-center">
                    <!-- Authentication Links -->
                    <jet-dropdown id="notificationDropdown" class="mr-2">
                        <template #trigger>
                            <img src="/images/icons/bell.svg" alt="">
                        </template>

                        <template #content>
                            <div class="p-3">
                                Notifications...
                            </div>
                        </template>
                    </jet-dropdown>


                    <!-- Authentication Links -->
                    <jet-dropdown id="settingsDropdown">
                        <template #trigger>
                            <img v-if="$page.props.jetstream.managesProfilePhotos" class="rounded-circle" width="32" height="32" :src="$page.props.student.profile_photo_url" :alt="$page.props.student.name" />
                            <span v-else>
                                <img class="rounded-circle" width="32" height="32" src="https://i.pinimg.com/originals/51/f6/fb/51f6fb256629fc755b8870c801092942.png"/>
                                Howdy, {{ $page.props.student.name }}
                                <svg class="ml-2" width="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd" />
                                </svg>
                            </span>
                        </template>

                        <template #content>
                            <!-- Account Management -->
                            <h6 class="dropdown-header small text-muted">
                                Manage Account
                            </h6>

                            <jet-dropdown-link :href="route('profile.show')" class="font-weight-semi-bold d-flex align-items-center">
                                <img class="mr-2" src="/images/icons/user-cog.svg" alt=""> Profile
                            </jet-dropdown-link>

                            <jet-dropdown-link :href="route('api-tokens.index')" v-if="$page.student.jetstream.hasApiFeatures">
                                API Tokens
                            </jet-dropdown-link>

                            <hr class="dropdown-divider">

                            <!-- Authentication -->
                            <form @submit.prevent="logout">
                                <jet-dropdown-link as="button" class="font-weight-semi-bold text-secondary d-flex align-items-center">
                                    <img class="mr-2" src="/images/icons/logout-secondary.svg" alt=""> Log out
                                </jet-dropdown-link>
                            </form>
                        </template>
                    </jet-dropdown>
                </ul>

            </div>

        </div>
    </nav>
</template>

<script>
import JetDropdown from "@/Jetstream/Dropdown";
import JetDropdownLink from "@/Jetstream/DropdownLink";
export default {
    name: "StudentNav",
    components: {JetDropdown, JetDropdownLink},
}
</script>

<style scoped>

</style>
